export const hasApiCallInProgress = (state) => state.api.callsInProgress.length > 0;
